import z from 'zod';

export const orgsWithEnabledConnectionsForUser = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
    enabledConnections: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
        strategy: z.string(),
      }),
    ),
  }),
);
